import { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { useAppDispatch } from "../../../hooks";
import { sortLocations } from "../../../redux/features/locationsSlice";

import "./Sort.scss";

function Sort() {
  const dispatch = useAppDispatch();
  const [sort, setSort] = useState("name asc");

  useEffect(() => {
    const s = sort.split(" ")[0];
    const o = (sort.split(" ")[1] as "asc" | "desc") ?? "asc";
    dispatch(sortLocations({ sort: s, order: o }));
  }, [dispatch, sort]);

  return (
    <FormControl fullWidth>
      <InputLabel>Sort by</InputLabel>
      <Select
        value={sort}
        onChange={(e) => setSort(e.target.value)}
        label="Sort by"
      >
        <MenuItem value="date asc">Earliest Selection Date</MenuItem>
        <MenuItem value="date desc">Latest Selection Date</MenuItem>
        <MenuItem value="name asc">Name</MenuItem>
        <MenuItem value="region asc">Region</MenuItem>
        <MenuItem value="state asc">State</MenuItem>
        <MenuItem value="timeline asc">Selection Timeline Type</MenuItem>
      </Select>
    </FormControl>
  );
}

export default Sort;
